module.exports = __webpack_public_path__ + "static/img/produto_p.eea0d6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/spremidos-uva/produto_p.png
// module id = R45R
// module chunks = 0